import gql from 'graphql-tag'

// PUZZLES

export const puzzleListProperties = `
    id
    created_at
    published
    start_date
    words {  
        word  
        is_bonus
    }
`

export const puzzleDetailProperties = `
    id
    published
    start_date
    created_at
    words {
        id
        word
        tip
        href
        is_bonus
        opengraph_data
        cells {
            id
            char
            index
            row
            column
            word_id
        }
    }
`

export const GET_PUZZLES = gql`
    query getPuzzles($limit: Int, $page: Int, $published: Boolean) {
        puzzles(limit: $limit, page: $page, published: $published) {
            data {
                ${puzzleListProperties}
            }
            total
        }
    }
`

export const GET_PUZZLE_BY_ID = gql`
    query getPuzzleById($id: ID!) {
        puzzle(id: $id) {
            ${puzzleDetailProperties}
        }
    }
`

export const GET_PUBLISHED_PUZZLE = gql`
    query getPublishedPuzzle {
        published_puzzle {
            ${puzzleDetailProperties}
        }
    }
`

export const GENERATE_PUZZLE = gql`
    query getPublishedPuzzle {
        generate_puzzle {
            words {
                word
                tip
                href
                is_bonus
                cells {
                    char
                    index
                    row
                    column
                }
            }
        }
    }
`

const savePuzzleParams = `
    $start_date: String!,
    $published: Boolean!,
    $words: [WordInput]
`

const savePuzzlePostData = `
    start_date: $start_date,
    published: $published,
    words: $words
`

export const CREATE_PUZZLE = gql`
    mutation createPuzzle(
        ${savePuzzleParams}

    ) {
        create_puzzle(
            ${savePuzzlePostData}
        ) {
            ${puzzleDetailProperties}
        }
    }
`

export const UPDATE_PUZZLE = gql`
    mutation updatePuzzle(
        $id: ID!,
        ${savePuzzleParams}

    ) {
        update_puzzle(
            id: $id,
            ${savePuzzlePostData}
        ) {
            ${puzzleDetailProperties}
        }
    }
`

// TEXTS

const textProperties = `
    id
    title
    body
    button_text
    realm
`

export const GET_TEXTS = gql`
    query getTexts {
        texts {
            ${textProperties}
        }
    }
`

export const GET_TEXT_BY_ID = gql`
    query getTextByID($id: ID!) {
        text(id: $id) {
            ${textProperties}
        }
    }
`

export const CREATE_TEXT = gql`
    mutation createText(
        $title: String!,
        $body: String!,
        $button_text: String,
        $realm: String!
    ) {
        create_text(
            title: $title,
            body: $body,
            button_text: $button_text,
            realm: $realm,
        ) {
            ${textProperties}
        }
    }
`

export const UPDATE_TEXT = gql`
  mutation updateText(
      $id: ID!,
      $title: String!,
      $body: String!,
      $button_text: String,
      $realm: String!
    ) {
        update_text(
            id: $id,
            title: $title,
            body: $body,
            button_text: $button_text,
            realm: $realm,
        ) {
            ${textProperties}
        }
    }
`

// Admin

export const LOGIN = gql`
    mutation loginCall($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            token
        }
    }
`

export const WHO_AM_I = gql`
    mutation WhoAmI {
        who_am_i {
            name, email
        }
    }
`
